import React from 'react'
import { Divider, Container, Box } from 'pcln-design-system'
import { useContentful } from '@pcln/contentful-components'
import PromoBanners from '@/components/MerchModuleWrapper/PromoBanners'
import AdBanner from '@/components/AdBanner'
import { AdBox, AdContent } from '@/components/AdContent'
import AppDownloadWrapper from '@/components/AppDownloadWrapper'
import SEOLinks from '@/components/SEOLinks'
import { EmailSignUpComponent } from '@/components/EmailSignUp'
import { ANALYTICS_CATEGORY_HOTELS } from '@/constants/analytics'
import SEOPRODUCTLINKS from '@/constants/seo-product-links'
import WhyPricelineBanner from '@/components/WhyPricelineBanner'
import { REASONS_HOTELS_LP } from '@/constants/reasons'
import { CustomMerchModule, CustomToutType } from '@/types'
import HotelsDealModule from '../HotelsDealModule'
import ExpressDealPromo from '../ExpressDeal/ExpressDealPromo'

const { GLOBAL, USA, EUROPE, ASIA, INTERNATIONAL } =
  SEOPRODUCTLINKS.HOTELS.links.exploreDeals

const HotelsContent = () => {
  const toutBanners: any = useContentful('toutBanners')
  const promoItems: CustomToutType[] | CustomMerchModule[] =
    toutBanners?.items || []
  return (
    <>
      <Divider borderColor="border.base" my={0} />
      <WhyPricelineBanner content={REASONS_HOTELS_LP} />
      <AdContent>
        <AdBox type="primary">
          <div id="div-gpt-ad-1509978848821-0" />
        </AdBox>
        <AdBox type="secondary">
          <div id="div-gpt-ad-1509978930813-0" />
        </AdBox>
        <AdBox type="tertiary">
          <div id="div-gpt-ad-1509129580404-0" />
        </AdBox>
      </AdContent>
      <EmailSignUpComponent
        sourceId="LANDING_HOTEL"
        category={ANALYTICS_CATEGORY_HOTELS}
      />
      <HotelsDealModule />
      <ExpressDealPromo />
      <PromoBanners merchModules={promoItems} />
      <Container>
        <Box
          color="background.light"
          boxShadowSize="sm"
          borderRadius="xl"
          mx={4}
          pr={[3, null, null, null, 4, 5]}
          pl={4}
        >
          <AppDownloadWrapper category={ANALYTICS_CATEGORY_HOTELS} />
        </Box>
      </Container>
      <AdBanner>
        <div id="div-gpt-ad-1509129866793-0" />
      </AdBanner>
      {[USA, EUROPE, ASIA, INTERNATIONAL, GLOBAL].map(location => (
        <SEOLinks
          key={location.action}
          caption={location.caption}
          category={ANALYTICS_CATEGORY_HOTELS}
          gaAction={location.action}
          links={location.items}
        />
      ))}
      <Divider borderColor="border.base" my={0} />
    </>
  )
}

export default HotelsContent
